import { FormInputTypes } from '@components/_old/dynamicForm';
import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';
import { IListingFilterWidgetSection } from '@components/widgets/listing-filter-widget';
import { IAbstractRecord } from '@models';
 
export const headers: Record<string, EnhancedTableHeader> = {
  Configuration_Provider_ProviderCode: {
    name: 'code',
    title: 'Code',
    type: EnhancedTableHeaderType.Link,
    urlTemplate: '/configuration/providers/{id}',
    openUrlInNewTab: false,
  },
  Person_FullName: {
    name: 'name',
    title: 'Name',
    type: EnhancedTableHeaderType.Link,
    urlTemplate: '/configuration/providers/{id}',
    openUrlInNewTab: false,
  },
  Configuration_Provider_Type: {
    name: 'type',
    title: 'Type',
    type: EnhancedTableHeaderType.Text,
  },
  Person_Email: {
    name: 'email',
    title: 'Email',
    type: EnhancedTableHeaderType.Text,
    disableSort: true,
  },
  phoneNumber: {
    name: 'phoneNumber',
    title: 'Phone Number',
    type: EnhancedTableHeaderType.PhoneNumber,
    disableSort: true,
  },
  Configuration_Provider_Status: {
    name: 'status',
    title: 'Status',
    type: EnhancedTableHeaderType.Text,
  },
  Configuration_Provider_createdOn: {
    name: 'createdOn',
    title: 'Created On',
    type: EnhancedTableHeaderType.Date,
  },
  Configuration_Provider_modifiedOn: {
    name: 'modifiedOn',
    title: 'Modified on',
    type: EnhancedTableHeaderType.Date,
  },
};

export function filterSectionsContent(
  lovs: Record<string, Record<string, string>>,
  filterValues: IAbstractRecord
): IListingFilterWidgetSection[] {
  const newFilterSections: IListingFilterWidgetSection[] = [
    {
      title: 'Filters',
      inputs: {
        type: {
          name: 'type',
          title: 'Type',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.type || [],
          placeholder: 'Type',
          triggerUpdate: true,
          selectOptions: { ...lovs.type },
        },
        status: {
          name: 'status',
          title: 'Status',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.status || [],
          placeholder: 'Status',
          triggerUpdate: true,
          selectOptions: { ...lovs.status },
        },
        isCompany: {
          name: 'isCompany',
          title: 'Is Company',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.isCompany || [],
          placeholder: 'Is Company',
          triggerUpdate: true,
          selectOptions: {
            true: 'Yes',
            false: 'No',
          },
        },
        isLocal: {
          name: 'isLocal',
          title: 'Is Local',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.isLocal || [],
          placeholder: 'Is Local',
          triggerUpdate: true,
          selectOptions: {
            true: 'Yes',
            false: 'No',
          },
        },
        createdOn: {
          name: 'createdOn',
          title: 'Created On',
          type: FormInputTypes.newdaterange,
          value: filterValues.createdOn || [],
          placeholder: 'Created On',
          triggerUpdate: true,
        },
        effectiveDate: {
          name: 'effectiveDate',
          title: 'Effective Date',
          type: FormInputTypes.newdaterange,
          value: filterValues.effectiveDate || [],
          placeholder: 'Effective Date',
          triggerUpdate: true,
        },
      },
    },
  ];
  return newFilterSections;
}
